<template>
  <div>
    <div :class="appTheme" class="pt-0.5">
      <AppHeader />
      <!-- <transition name="fade" mode="out-in">
        <router-view :theme="appTheme" />
      </transition> -->
      <router-view v-slot="{ Component, route }">
        <transition name="fade" mode="out-in">
          <component :theme="appTheme" :is="Component" :key="route.path" />
        </transition>
      </router-view>
      <!-- Scroll to top -->
      <back-to-top visibleoffset="500" right="30px" bottom="20px" class="shadow-lg">
        <i data-feather="chevron-up"></i>
      </back-to-top>
      <!-- App Footer -->
      <AppFooter />
    </div>
  </div>
</template>

<script>
import feather from 'feather-icons';
import AppHeader from './components/shared/AppHeader.vue';
import AppFooter from './components/shared/AppFooter.vue';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      appTheme: localStorage.getItem('theme'),
    };
  },
  mounted() {
    feather.replace();
  },
  updated() {
    feather.replace();
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.vue-back-to-top {
  @apply p-2 bg-cyan-500 text-white transition duration-500 ease-in-out transform;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}

.vue-back-to-top,
.vue-back-to-top:hover {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.vue-back-to-top:hover {
  --tw-translate-y: -0.25rem;
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229/var(--tw-bg-opacity));
}

.vue-back-to-top {
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px
}

.fade-enter-active {
  animation: coming .4s;
  animation-delay: .2s;
  opacity: 0
}

.fade-leave-active {
  animation: going .4s
}

.fade-enter-active {
  animation: coming 0.4s;
  animation-delay: 0.2s;
  opacity: 0;
}

.fade-leave-active {
  animation: going 0.4s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-10px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-10px);
    opacity: 0;
  }

  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

/* .bg-primary-dark {
  background-color: #434446!important;
} */
</style>
